/**
 * In-modal reference for the paper-journal CSV layout.
 */

import React, { useCallback, useState } from 'react';
import {
  PAPER_JOURNAL_CSV_COLUMNS,
  PAPER_JOURNAL_CSV_HEADER_LINE,
} from '@/pages/PaperJournal/paperJournalCsvFormat';

import './PaperJournalCsvFormatGuide.scss';

export const PaperJournalCsvFormatGuide: React.FC = () => {
  const [copied, setCopied] = useState(false);

  const handleCopyHeader = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(PAPER_JOURNAL_CSV_HEADER_LINE);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  }, []);

  return (
    <section
      className="paper-journal-csv-format"
      aria-labelledby="paper-journal-csv-format-heading"
    >
      <h3 id="paper-journal-csv-format-heading" className="paper-journal-csv-format__title">
        Required CSV format
      </h3>
      <p className="paper-journal-csv-format__lede">
        Upload a UTF-8 comma-separated file with exactly one header row, then one row per participant.
        Column names are case-sensitive. The same file cannot be uploaded twice.
      </p>

      <div className="paper-journal-csv-format__header-block">
        <div className="paper-journal-csv-format__header-label">Header row</div>
        <code className="paper-journal-csv-format__header-line">{PAPER_JOURNAL_CSV_HEADER_LINE}</code>
        <button
          type="button"
          className="paper-journal-csv-format__copy"
          onClick={() => void handleCopyHeader()}
        >
          {copied ? 'Copied' : 'Copy header row'}
        </button>
      </div>

      <div className="paper-journal-csv-format__table-wrap">
        <table className="paper-journal-csv-format__table">
          <thead>
            <tr>
              <th scope="col">Column</th>
              <th scope="col">Required</th>
              <th scope="col">Description</th>
              <th scope="col">Example</th>
            </tr>
          </thead>
          <tbody>
            {PAPER_JOURNAL_CSV_COLUMNS.map((col) => (
              <tr key={col.header}>
                <td>
                  <code>{col.header}</code>
                </td>
                <td>{col.required ? 'Yes' : 'No'}</td>
                <td>{col.description}</td>
                <td>
                  {col.example !== '' ? (
                    <code>{col.example}</code>
                  ) : (
                    <span className="paper-journal-csv-format__empty-example">—</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default PaperJournalCsvFormatGuide;
